import { render } from "./IcelandFlights.vue?vue&type=template&id=be705e14"
import script from "./IcelandFlights.vue?vue&type=script&lang=js"
export * from "./IcelandFlights.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__